import React from 'react';
import { useNavigate } from 'react-router';
import { Container } from '@/components/ui/container';
import { Stack, Inline } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { Button } from '@/components/ui/button';
import { PlayCircle, ArrowRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import { getColor } from '@/config/theme';

const HeroSection = () => {
    const navigate = useNavigate();
    return (
        <section className={cn(
            "relative py-12 md:py-16 lg:py-20 overflow-hidden",
            "bg-gradient-to-br from-primary/10 via-primary/5 to-background"
        )}>
            <Container>
                <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
                    {/* Content */}
                    <div className="flex-1 text-center lg:text-left">
                        <Stack spacing="lg">
                            <Heading level="h1" className="text-3xl md:text-4xl lg:text-5xl font-bold">
                                Transform and Reinvent Recruitment with{' '}
                                <span className="text-primary">AI-Driven Solution</span>
                            </Heading>
                            <Text size="lg" variant="muted" className="max-w-2xl mx-auto lg:mx-0">
                                Empower your team with a fair, empathetic & data-driven hiring
                                process with power of AI. Discover how AI's Evaluation in
                                recruitment can help in your next best hire.
                            </Text>
                            <Inline spacing="md" className="justify-center lg:justify-start">
                                <Button
                                    size="lg"
                                    onClick={() => navigate('/login_user')}
                                    style={{
                                        backgroundColor: getColor('primary'),
                                        color: getColor('primaryForeground'),
                                    }}
                                    className="gap-2"
                                >
                                    <ArrowRight className="h-5 w-5" />
                                    Get Started
                                </Button>
                                <Button
                                    variant="outline"
                                    size="lg"
                                    className="gap-2"
                                >
                                    <PlayCircle className="h-5 w-5" />
                                    How it Works
                                </Button>
                            </Inline>
                        </Stack>
                    </div>
                    {/* Hero Image */}
                    <div className="flex-1 flex items-center justify-center">
                        <img
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/95ff9a1c82c07043971d17d43d37d0d07479de22533b95c36cf3bc80877d11ba?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214"
                            alt="Hero Image"
                            className="w-full max-w-lg object-contain"
                        />
                    </div>
                </div>
            </Container>
        </section>
    );
}

export default HeroSection;